import { Component, OnInit } from '@angular/core';
import { AlertService, AppService, PastEventService } from '../_services';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OtpLogsService } from '../_services/otp-logs.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-otp-logs',
  templateUrl: './otp-logs.component.html',
  styleUrls: []
})
export class OtpLogsComponent implements OnInit {

  showloding = true;
  dtTrigger = new Subject();
  optLogsList: any[] = [];
  lodingImage = false;
  dtOptions: DataTables.Settings = {};

  constructor(
    public router: Router,
              private dataService:OtpLogsService,
              private alertService: AlertService,
              private AppService: AppService,
              private toastr: ToastrService
  ) { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getLogs()
  }


  getLogs(){
    this.loadShow();
    this.dataService.getOtpLogs().subscribe((res:any)=>{
      console.log(res,"resssss...");
      this.optLogsList = res['log']
      this.dtTrigger.next();
      this.loadHide();

    })
   }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

}
